export const bar = [
  { name: "home", link: "#Header" },
  { name: "about", link: "#About" },
  { name: "skills", link: "#Experience" },
  { name: "portfolio", link: "#Portfolio" },
  { name: "contacts", link: "#Contacts" },
];
export const card = [
  { imgUrl: "./assets/icon1.png", title: "HTML" },
  { imgUrl: "./assets/icon2.png", title: "CSS" },
  { imgUrl: "./assets/icon3.png", title: "Javascript" },
  { imgUrl: "./assets/icon4.png", title: "React" },
  { imgUrl: "./assets/icon55.png", title: "Git" },
  { imgUrl: "./assets/icon7.png", title: "Bootstrap" },
];
